import { lazy } from 'react';

const LandingPage = lazy(async () => {
  const module = await import('../../pages/LandingPage');
  return { default: module.LandingPage };
});

const PreviewPage = lazy(async () => {
  const module = await import('../../pages/PreviewPage');
  return { default: module.PreviewPage };
});

const PlanPage = lazy(async () => {
  const module = await import('../../pages/PlanPage');
  return { default: module.PlanPage };
});

const PrivacyRequestsPage = lazy(async () => {
  const module = await import('../../pages/PrivacyRequestsPage');
  return { default: module.PrivacyRequestsPage };
});

const ReportsPage = lazy(async () => {
  const module = await import('../../pages/ReportsPage');
  return { default: module.ReportsPage };
});

const ResetPasswordConfirmPage = lazy(async () => {
  const module = await import('../../pages/ResetPasswordConfirmPage');
  return { default: module.ResetPasswordConfirmPage };
});

const ResetPasswordPage = lazy(async () => {
  const module = await import('../../pages/ResetPasswordPage');
  return { default: module.ResetPasswordPage };
});

const SessionExpired = lazy(async () => {
  const module = await import('../../pages/SessionExpired');
  return { default: module.SessionExpired };
});

const SuperuserPage = lazy(async () => {
  const module = await import('../../pages/SuperuserPage');
  return { default: module.SuperuserPage };
});

const UserSettingsPage = lazy(async () => {
  const module = await import('../../pages/UserSettingsPage');
  return { default: module.UserSettingsPage };
});

const VerifyEmailPage = lazy(async () => {
  const module = await import('../../pages/VerifyEmailPage');
  return { default: module.VerifyEmailPage };
});

const ExecutionRunsPage = lazy(async () => {
  const module = await import('@/features/executionRuns/pages/ExecutionRunsPage');
  return { default: module.ExecutionRunsPage };
});

const BuildDetailPage = lazy(async () => {
  const module = await import('@/features/builds/routes');
  return { default: module.BuildDetailPage };
});

const JobRunDetailPage = lazy(async () => {
  const module = await import('@/features/builds/routes');
  return { default: module.JobRunDetailPage };
});

const ExecutionRunDetailPage = lazy(async () => {
  const module = await import('@/features/executionRuns/pages/ExecutionRunDetailPage');
  return { default: module.ExecutionRunDetailPage };
});

const FeatureDetailPage = lazy(async () => {
  const module = await import('@/features/features/routes');
  return { default: module.FeatureDetailPage };
});

const FeaturesPage = lazy(async () => {
  const module = await import('@/features/features/routes');
  return { default: module.FeaturesPage };
});

const OnboardingPage = lazy(async () => {
  const module = await import('@/features/onboarding/pages/OnboardingPage');
  return { default: module.OnboardingPage };
});

const OnboardingDebugIndexPage = lazy(async () => {
  const module = await import('@/features/onboardingDebug/pages/OnboardingDebugIndexPage');
  return { default: module.OnboardingDebugIndexPage };
});

const OnboardingDebugScreenPage = lazy(async () => {
  const module = await import('@/features/onboardingDebug/pages/OnboardingDebugScreenPage');
  return { default: module.OnboardingDebugScreenPage };
});

const OrganisationSettingsPage = lazy(async () => {
  const module = await import('@/features/organisations/pages/OrganisationSettingsPage');
  return { default: module.OrganisationSettingsPage };
});

const ProjectDetailPage = lazy(async () => {
  const module = await import('@/features/projects/routes');
  return { default: module.ProjectDetailPage };
});

const PipelineDetailPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/PipelineDetailPage');
  return { default: module.PipelineDetailPage };
});

const PipelinesPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/PipelinesPage');
  return { default: module.PipelinesPage };
});

const StagesPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/StagesPage');
  return { default: module.StagesPage };
});

const StageDetailPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/StageDetailPage');
  return { default: module.StageDetailPage };
});

const StageExecutionDetailPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/StageExecutionDetailPage');
  return { default: module.StageExecutionDetailPage };
});

const JobDetailPage = lazy(async () => {
  const module = await import('@/features/jobs/routes');
  return { default: module.JobDetailPage };
});

const JobsPage = lazy(async () => {
  const module = await import('@/features/jobs/routes');
  return { default: module.JobsPage };
});

const ReleaseDetailPage = lazy(async () => {
  const module = await import('@/features/releases/routes');
  return { default: module.ReleaseDetailPage };
});

const ReleasesPage = lazy(async () => {
  const module = await import('@/features/releases/routes');
  return { default: module.ReleasesPage };
});

const SignInPage = lazy(async () => {
  const module = await import('../../pages/SignInPage');
  return { default: module.SignInPage };
});

const SignUpPage = lazy(async () => {
  const module = await import('../../pages/SignUpPage');
  return { default: module.SignUpPage };
});

const AuthCallbackPage = lazy(async () => {
  const module = await import('../../pages/AuthCallbackPage');
  return { default: module.AuthCallbackPage };
});

const AcceptInvitationPage = lazy(async () => {
  const module = await import('../../pages/AcceptInvitationPage');
  return { default: module.AcceptInvitationPage };
});

const SuiteDetailPage = lazy(async () => {
  const module = await import('@/features/suites/routes');
  return { default: module.SuiteDetailPage };
});

const SuiteRunDetailPage = lazy(async () => {
  const module = await import('@/features/executions/routes');
  return { default: module.SuiteRunDetailPage };
});

const SuitesPage = lazy(async () => {
  const module = await import('@/features/suites/routes');
  return { default: module.SuitesPage };
});

const TestDetailPage = lazy(async () => {
  const module = await import('@/features/tests/routes');
  return { default: module.TestDetailPage };
});

const TestRunDetailPage = lazy(async () => {
  const module = await import('@/features/executions/routes');
  return { default: module.TestRunDetailPage };
});

const TestsPage = lazy(async () => {
  const module = await import('@/features/tests/routes');
  return { default: module.TestsPage };
});

const ResultsFileDetailPage = lazy(async () => {
  const module = await import('@/features/uploads/routes');
  return { default: module.ResultsFileDetailPage };
});

const UploadDetailPage = lazy(async () => {
  const module = await import('@/features/uploads/routes');
  return { default: module.UploadDetailPage };
});

export {
  AcceptInvitationPage,
  AuthCallbackPage,
  BuildDetailPage,
  ExecutionRunDetailPage,
  ExecutionRunsPage,
  FeatureDetailPage,
  FeaturesPage,
  JobDetailPage,
  JobRunDetailPage,
  JobsPage,
  LandingPage,
  OnboardingDebugIndexPage,
  OnboardingDebugScreenPage,
  OnboardingPage,
  OrganisationSettingsPage,
  ProjectDetailPage,
  PipelineDetailPage,
  PipelinesPage,
  PlanPage,
  PreviewPage,
  PrivacyRequestsPage,
  ReleaseDetailPage,
  ReleasesPage,
  ReportsPage,
  ResetPasswordConfirmPage,
  ResetPasswordPage,
  ResultsFileDetailPage,
  SessionExpired,
  SignInPage,
  SignUpPage,
  StageDetailPage,
  StageExecutionDetailPage,
  StagesPage,
  SuiteDetailPage,
  SuiteRunDetailPage,
  SuitesPage,
  SuperuserPage,
  TestDetailPage,
  TestRunDetailPage,
  TestsPage,
  UploadDetailPage,
  UserSettingsPage,
  VerifyEmailPage,
};
